module.exports = __webpack_public_path__ + "img/full1-min.59551b93.png";